import { Grid, GridItem, Text, VStack } from '@chakra-ui/react';
import { SystemParamFormFields } from '@components/cockpit/panels/systemParameters/systemStorage/SystemStorage';
import { FormattedMessage } from 'react-intl';

type SystemParametersOverviewProps = {
  cachedValues: SystemParamFormFields;
};

export function SystemStorageOverview({ cachedValues }: Readonly<SystemParametersOverviewProps>) {
  return (
    <VStack gap={5}>
      <Grid templateColumns="repeat(2,1fr)" templateRows="repeat(2,1fr)" gap={5}>
        <GridItem width="251px" display="flex" flexDirection="column" gap={1.5}>
          <Text color="neutral.300">
            <FormattedMessage id="components.systemParameters.sensorRawStorage" />
          </Text>
          <Text>
            {cachedValues.enabledSensorRawStorage ? (
              <FormattedMessage
                id="components.systemParameters.dayLabel"
                values={{ count: cachedValues.sensorRawStorageDuration }}
              />
            ) : (
              <FormattedMessage id="components.systemParameters.disabledStorage" />
            )}
          </Text>
        </GridItem>

        <GridItem width="251px" display="flex" flexDirection="column" justifyContent="start" gap={1.5}>
          <Text color="neutral.300">
            <FormattedMessage id="components.systemParameters.situationStorage" />
          </Text>
          <Text>
            {cachedValues.enabledSituationStorage ? (
              <FormattedMessage
                id="components.systemParameters.dayLabel"
                values={{ count: cachedValues.situationStorageDuration }}
              />
            ) : (
              <FormattedMessage id="components.systemParameters.disabledStorage" />
            )}
          </Text>
        </GridItem>

        <GridItem width="251px" display="flex" flexDirection="column" justifyContent="start" gap={1.5}>
          <Text color="neutral.300">
            <FormattedMessage id="components.systemParameters.ladVideoStreamStorage" />
          </Text>
          <Text>
            {cachedValues.enabledLadVideoStreamStorage ? (
              <FormattedMessage
                id="components.systemParameters.hourLabel"
                values={{ count: cachedValues.ladVideoStreamStorageDuration }}
              />
            ) : (
              <FormattedMessage id="components.systemParameters.disabledStorage" />
            )}
          </Text>
        </GridItem>
      </Grid>
    </VStack>
  );
}
